/**
 * Web Style Import
 *
 */

import './style/dnb-forms.scss'
